import React from 'react';
import LeagueTableWidget from './leagueTableWidget.jsx';
import Select2 from 'react-select2-wrapper';
import StatsWidget from './statsWidget.jsx';
import {store} from '../football_stats.jsx';

function showMoreStats( e) {
    store.dispatch({type: 'SHOW_MORE', val: store.getState().showMoreCount + 1});
}

function statsChanged(e) {

    console.log("In stats statsChanged: " + e.currentTarget.id + " - " + e.type + " - " +  e.currentTarget.value)
    if(e.type == 'select2:select' || e.type == 'select2:unselect' ) { //item selected

        let value = e.currentTarget.value;

        switch (e.currentTarget.id) {
            case ('selectTeam'):
                if(!(e.type == 'select2:select' && value == null)) //We don't send null selected events
                {
                    store.dispatch({type: 'SELECT_TEAM', val: e.type == 'select2:select' ? value: null});
                }
                break;
            case ('selectPlayer'):
                if(!(e.type == 'select2:select' && value == null)) //We don't send null selected events
                {
                    store.dispatch({type: 'SELECT_PLAYER', val: e.type == 'select2:select' ? value : null});
                }
                break;
            case ('selectPosition'):
                if(!(e.type == 'select2:select' && value == null)) //We don't send null selected events
                {
                    store.dispatch({type: 'SELECT_POSITION', val: e.type == 'select2:select' ? value : null});
                }
                break;
            case ('selectSeason'):
                store.dispatch({type: "STATS_LOADING", val: true});
                store.dispatch({type: 'SELECT_SEASON', val: value});
                break;
            case ('selectLeague'):
                store.dispatch({type: "STATS_LOADING", val: true});
                store.dispatch({type: 'SELECT_LEAGUE', val: value});
                break;
            case ('selectType'):
                store.dispatch({type: 'SELECT_TYPE', val: value});
                break;
            case ('selectStage'):
                store.dispatch({type: "STATS_LOADING", val: true});
                store.dispatch({type: "SELECT_STAGE", val: e.type == 'select2:select' ? value : null});
                break;
            case ('selectRound'):
                store.dispatch({type: "STATS_LOADING", val: true});
                store.dispatch({type: 'SELECT_ROUND', val: e.type == 'select2:select' ? value: 0});
                break;
            default:
        }
    }

    return true;
}

const StatsPageWidget = ({
    loading,
    categories,
    players,
    teams,
    rounds,
    stats,
    selectedRound=0,
    selectedSeason="26/27",
    selectedLeague="902",
    statsFilter= {},
    selectedType="player",
    selectedStage,
    showMoreCount=1
}) => {

    let selectTeamOptions = {
        placeholder: {id: -1, text: getByLang('Select Team' ,'חיפוש קבוצה', 'ابحث عن فريق'), value: -1},
        // minimumResultsForSearch: -1,
        allowClear: true
    };

    //TODO: add new season when starts:
    let selectSeasonData = [
        {value: "19/20", id:"19/20", text: "19/20"},
        {value: "20/21", id:"20/21", text: "20/21"},
        {value: "21/22", id:"21/22", text: "21/22"},
        {value: "22/23", id:"22/23", text: "22/23"},
        {value: "23/24", id:"23/24", text: "23/24"},
        {value: "24/25", id:"24/25", text: "24/25"},
        {value: "25/26", id:"25/26", text: "25/26"},
        {value: "26/27", id:"26/27", text: "26/27"}
    ];

    if(selectedLeague == 902) { //Adding previous seasons to Ligat Ha'al
        selectSeasonData.unshift(
            {value: "16/17", id:"16/17", text: "16/17"},
            {value: "17/18", id:"17/18", text: "17/18"},
            {value: "18/19", id:"18/19", text: "18/19"}
        );
    }

    let selectStageData = [
        {
            value: "",
            text: getByLang('All Season', 'כל העונה', ''),
            id: "allSeason"
        },
        {
            value: "RegularSeason",
            text: getByLang('Regular Season', 'עונה סדירה', ''),
            id: "regularSeason"
        },
        {
            value: selectedLeague == 902 ? "ChampionshipRound" : "ChampionshipRound",
            text: getByLang('Promotion Round', 'פלייאוף עליון', ''),
            id: selectedLeague == 902 ? "championshipRound" : "championshipRound"
        },
        {
            value: "RelegationRound",
            text: getByLang('Relegation Round', 'פלייאוף תחתון', ''),
            id: "relegationRound"
        }
    ];

    let selectStageOptions = {
        placeholder: {id: 'select-stage', text: getByLang('Select Stage' ,'בחר שלב', 'حدد المرحلة'), value: null},
        minimumResultsForSearch: 1,
        allowClear: true
    };

    let selectLeagueData = [
        {value: "902", id:"902", text: getByLang('Ligat Winner' ,'ליגת Winner', 'الدوري الممتاز')},
    ];

    if(['16/17', '17/18', '18/19'].indexOf(selectedSeason) < 0) { //Not 16/17/18/19
        selectLeagueData.push({value: "719", id:"719", text: getByLang('Liga Winner Leumit' ,'ליגה לאומית', '')});
    }

    let selectSeasonOptions = {
        minimumResultsForSearch: 1
    };

    let selectLeagueOptions = {
        minimumResultsForSearch: 1
    };
    let isRegularSeason = selectedStage === 'RegularSeason' || selectedStage == null;
    let selectRoundOptions = {
        placeholder: {id: 0, text: getByLang('Select Round' ,'חיפוש מחזור', 'ابحث عن الدورة'), value: isRegularSeason ? 0 : 1},
        allowClear: true
    };

    let i = 0;
    let selectRoundData = [];
    let roundsCounter = selectedLeague === '902' ? 26 : 30;

    if(selectedStage === 'ChampionshipRound' && selectedLeague === '902') {
        i = 1;
        roundsCounter = 10;
    } else if(selectedStage === 'RelegationRound' && selectedLeague === '902') {
        i = 1;
        roundsCounter = 7;
    } else if(selectedStage === 'RelegationRound' || selectedStage === 'ChampionshipRound' && selectedLeague == 719){ // relegation
        roundsCounter = 7;
        i = 1;
    }

    for (i; i <= roundsCounter; i++) {
        if(i === 0){
            selectRoundData[i] = {value: i, text: getByLang('Season Total' ,'סטטיסטיקה עונתית', ''), id: i};
        }else {
            selectRoundData[i] = {value: i, text: i, id: i};
        }
    }

    let selectTeamData = Object.keys(teams)
        .filter((team)=> teams[team].leagues[selectedSeason] == selectedLeague)
        .map(function (key) {
        return {value: teams[key].id, text: getObjField(teams[key]), id: teams[key].id};
    });

    let selectOptions = {
        placeholder: {id: 0, text: getByLang('select player' ,'חיפוש שחקן', 'ابحث عن لاعب'), value: 0},
        allowClear: true
    };

    let playersSelect = Object.keys(players) ? Object.keys(players)
        .filter( (player) => {

            if(typeof statsFilter != 'undefined' && statsFilter != null && typeof statsFilter.teamId != 'undefined') {
                if(typeof players[player].clubs == 'undefined') {
                    var currentTeam = players[player].teamId;

                    if(typeof currentTeam == 'object') {
                        currentTeam = currentTeam.id;
                    }

                    if(statsFilter.teamId == currentTeam && currentSeason == selectedSeason) {
                        console.log("Team found! " + players[player].id + " currentTeam " + currentTeam + " current season " + currentSeason + " selectedSeason " + selectedSeason);
                        return true;
                    }

                    console.log("Missing clubs " + players[player].id + " currentTeam " + currentTeam + " current season " + currentSeason + " selectedSeason " + selectedSeason);
                    return false;
                }

                for (var i = 0; i < players[player].clubs.length; i++) {
                    var pastLeague = players[player].clubs[i].tournamentId != "undefined" ? players[player].clubs[i].tournamentId : -1;
                    var pastSeason = players[player].clubs[i].seasonName != 'undefined' ? players[player].clubs[i].seasonName : -1;
                    var pastTeamId = players[player].clubs[i].teamId;

                    if(statsFilter.teamId == pastTeamId && pastSeason == selectedSeason && selectedLeague == pastLeague) {
                        return true;
                    }
                }

                return false;
            }

            var playedOnSeason = (currentSeason == selectedSeason);

            if(!playedOnSeason) {
                for(i in players[player].clubs) {
                    var club = players[player].clubs[i];

                    if(club.seasonName == selectedSeason && club.tournamentId == selectedLeague) {
                        playedOnSeason = true;
                        break;
                    }
                }
            }

            return playedOnSeason || players[player].leagues[selectedSeason] == selectedLeague;
        })
        .map(function (key) {
            return {value: players[key].id, text: getObjField(players[key]), id: players[key].id}
        }) : [];

    let selectTypeOptions = {
        // minimumResultsForSearch: -1,
    };

    let selectTypeData = [
        {value: "player", id:"player", text: getByLang("Player", 'שחקן', 'لاعب')},
        {value: "team", id:"team", text: getByLang("Team", 'קבוצה', 'فريق')}
    ];

    let selectPositionData = [
        {value: "goalie", id:"goalie", text: getByLang("Goalie", 'שוער', 'حارس مرمى')},
        {value: "defenseman", id:"defenseman", text: getByLang("Defense", 'הגנה', 'الدفاع')},
        {value: "mid-fielder", id:"mid-fielder", text: getByLang("Midfielder",'קשר', 'خط وسط')},
        {value: "forward", id:"forward", text: getByLang("Forward", 'חלוץ', 'المُهاجم')}
    ];

    let selectPositionOptions = {
        placeholder: {id: null, text: getByLang('select position' ,'חיפוש עמדה', 'البحث عن مركز'), value: null},
        // minimumResultsForSearch: -1,
        allowClear: true
    };

    let selectedTeam;
    if(selectedType == 'player') {
        selectedTeam = typeof statsFilter.teamId != 'undefined' ? statsFilter.teamId : null;
    } else {
        selectedTeam = typeof statsFilter.id != 'undefined' ? statsFilter.id : null;
    }

    let selectedPosition = typeof statsFilter.position != 'undefined' ? statsFilter.position: null;

    let selectedPlayer = typeof statsFilter.id != 'undefined' && selectedType == 'player' &&
                         statsFilter.id != null && statsFilter.id != "" ? statsFilter.id : null;

    selectedStage = typeof statsFilter.stage != 'undefined' && statsFilter.stage != null && statsFilter.stage != "" ? statsFilter.stage : null;

    // let standings = typeof store != 'undefined' ? store.getState().standings : {};
    // let currentLeague = typeof store != 'undefined' ? store.getState().currentLeague : 902;
    // let currentGamesStage = typeof store != 'undefined' ? store.getState().currentGamesStage : "RegularSeason";
    // let regularSeasonEnd = typeof store != 'undefined' ? store.getState().regularSeasonEnd : false;
    // let regularSeasonEndLeumit = typeof store != 'undefined' ? store.getState().regularSeasonEndLeumit : false;

    return (
        <div>
            <ul className="stats-selector-list">
                <li className="stats-selector-item">
                    <Select2 id="selectType" className="stats-select"
                             value={selectedType}
                             onSelect={statsChanged}
                             onUnselect={statsChanged}
                             data={selectTypeData}
                             options={selectTypeOptions} />
                </li>

                <li className="stats-selector-item" >
                    <Select2 id="selectPosition" className="stats-select"
                             value={selectedPosition}
                             onSelect={statsChanged}
                             onUnselect={statsChanged}
                             data={selectPositionData}
                             options={selectPositionOptions}
                             disabled={selectedType === 'team'}
                    />
                </li>

                <li className="stats-selector-item">
                    <Select2 id="selectTeam" className="stats-select"
                             value={ selectedTeam }
                             onSelect={statsChanged}
                             onUnselect={statsChanged}
                             data={selectTeamData}
                             options={selectTeamOptions}
                    />
                </li>

                <li className="stats-selector-item">
                    <Select2 id="selectRound" className="stats-select"
                             value={selectedRound}
                             onSelect={statsChanged}
                             onUnselect={statsChanged}
                             data={selectRoundData}
                             options={selectRoundOptions} />
                </li>

                <li className="stats-selector-item">
                    <Select2 id="selectPlayer" className="stats-select"
                             value={selectedPlayer}
                             onSelect={statsChanged}
                             onUnselect={statsChanged}
                             data={playersSelect}
                             options={selectOptions}
                             disabled={selectedType === 'team'}
                    />
                </li>
                <li className="stats-selector-item">
                    <Select2 id="selectLeague" className="stats-select"
                             value={selectedLeague}
                             onSelect={statsChanged}
                             onUnselect={statsChanged}
                             data={selectLeagueData}
                             options={selectLeagueOptions} />
                </li>
                <li className="stats-selector-item">
                    <Select2 id="selectSeason" className="stats-select"
                             value={selectedSeason}
                             onSelect={statsChanged}
                             onUnselect={statsChanged}
                             data={selectSeasonData}
                             options={selectSeasonOptions} />
                </li>
                <li className={"stats-selector-item" }>
                    <Select2 id="selectStage" className="stats-select"
                             value={selectedStage}
                             onSelect={statsChanged}
                             onUnselect={statsChanged}
                             data={selectStageData}
                             options={selectStageOptions}/>
                </li>

            </ul>
            <div className="stats-divider"></div>
            {
                typeof store != 'undefined' && store.getState() ?
                    <div id="league-table-react">
                        <LeagueTableWidget
                           standings = { store.getState().standings }
                           currentLeague={ store.getState().currentLeague }
                           gamesStage={ store.getState().currentGamesStage }
                           regularSeasonEnd={ store.getState().regularSeasonEnd }
                           regularSeasonEndLeumit={ store.getState().regularSeasonEndLeumit}
                           leumitDisclaimer={leumitDisclaimer}
                           disclaimer={disclaimer} />
                    </div>
                    : ''
            }

            <div className={"stats-container"}>
                { categories.slice(0, 8 * showMoreCount).map( (cat, catIndex) => (
                        <div key={"statsWidgetDiv" + getObjField(cat)}  className=" no-padding col-xs-12 col-md-6 col-lg-3 ">
                            <StatsWidget key={ "statsWidget" + getObjField(cat)}
                                 loading={loading}
                                 type={selectedType}
                                 category={cat}
                                 players={ players }
                                 teams={teams}
                                 stats={stats}
                                 round={selectedRound}
                                 limit={typeof cat.isOpen != 'undefined' ? 500 : 5 }
                                 season={selectedSeason}
                                 league={selectedLeague}
                                 stage={selectedStage}
                                 filter={statsFilter}
                                 additionalClass=" no-padding "
                                 showAll="1"
                                 catIndex={catIndex}/>
                            <div className="stats-divider"></div>
                        </div>
                    )
                )}
            </div>
            { ( 8 * showMoreCount < categories.length) ?
                <button onClick={ showMoreStats } type="button" className="stats-see-more-btn">
                    <label className="stats-see-more-btn-label">  { getByLang('Show More', 'ראה עוד', 'لمشاهدة المزيد') } </label>
                </button>
                :
                ''
            }
        </div>
    );
};

export default StatsPageWidget;
